export const COLLECTION_PAGE_DATA_LOAD = 'COLLECTION_PAGE_DATA_LOAD';
export const COLLECTION_PAGE_DATA_SUCCESS = 'COLLECTION_PAGE_DATA_SUCCESS';
export const COLLECTION_PAGE_DATA_FAIL = 'COLLECTION_PAGE_DATA_FAIL';
export const COLLECTION_PAGE_RENDER_DATA_UPDATE = 'COLLECTION_PAGE_RENDER_DATA_UPDATE';
export const COLLECTION_MERGED_DATA_UPDATE = 'COLLECTION_MERGED_DATA_UPDATE';
